import React from "react";
import marufImage from "../../image/marufGif.gif";
import "./About.css";
import webDesign from "../../image/icon/WebDesi.png";
import webDevelopment from "../../image/icon/WebDesi.png";
import android from "../../image/icon/WebDesi.png";

const About = () => {
  return (
    <div id="about" className="container mt-5 text-link-color">
      <h2 class="text-center">About Me</h2>
      <hr className="horizantel-line" />
      <div className="row p-5">
        <div className="col-md-6">
          <div className="d-flex justify-content-center">
            <img
              className="img-fluid about-image border p-1"
              src={marufImage}
              alt=""
            />
          </div>
        </div>
        <div className="col-md-6 d-flex align-items-center s2">
          <div className="">
            <h2>ٱلسَّلَامُ عَلَيْكُمْ</h2>
            <p>
              I'm Mohammad Maruf. I have done my graduation in Computer Science
              & Engineering from East West University. I love computers. I spend
              couple of hours per day in front of a computer screen as I am
              coding, debugging, or discussing coding practices and methods with
              other programmers. I am a Full Stack Web Developer (MERN) and have
              quite some experience in it as well. I can build professional,
              custom websites for you!
            </p>
            <h4 className="mt-2">
              Full Name:{" "}
              <span className="about-image-side-text">Mohammad Maruf</span>
            </h4>
            <h4 className="mt-2">
              Nationality:{" "}
              <span className="about-image-side-text">Bangladeshi</span>
            </h4>
            <h4 className="mt-2">
              Language:{" "}
              <span className="about-image-side-text">Bangla, English</span>
            </h4>
            <h4 className="mt-2">
              Address:{" "}
              <span className="about-image-side-text">
                Kuril,Vatara,Dhaka-1229
              </span>
            </h4>
          </div>
        </div>
      </div>
      <div className="row mt-5 d-flex justify-content-center">
        <div className="">
          <h2 class="text-center">Services</h2>
          <hr className="horizantel-line" />
        </div>
        <div className="col-md-4 px-4 py-3">
          <div className="border p-4 rounded">
            <img src={webDesign} alt="" />
            <h5 className="mt-3">Web Design</h5>
            <p>
              I enjoy developing designs as I'm able to use them to give my
              imagination a layout when building a website.
            </p>
          </div>
        </div>
        <div className="col-md-4 px-4 py-3">
          <div className="border p-4 rounded">
            <img src={webDevelopment} alt="" />
            <h5 className="mt-3">Web Development</h5>
            <p>
              I am a Full Stack Web Developer (MERN) and have quite some
              experience in it as well.
            </p>
          </div>
        </div>
        <div className="col-md-4 px-4 py-3">
          <div className="border p-4 rounded">
            <img src={android} alt="" />
            <h5 className="mt-3">Problem Solving</h5>
            <p>I love to solve Data Structures and Algorithms problems on various 
               topics also love solving real life problems.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
